import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const MessageQuestion = ({ strokeWidth = 1.5 }): JSX.Element => {
    return (
        <>
            <g id={'contour'}>
                <path
                    d='M17 18.4297H13L8.54999 21.3897C7.88999 21.8297 7 21.3598 7 20.5598V18.4297C4 18.4297 2 16.4297 2 13.4297V7.42969C2
                     4.42969 4 2.42969 7 2.42969H17C20 2.42969 22 4.42969 22 7.42969V13.4297C22 16.4297 20 18.4297 17 18.4297Z'
                    strokeWidth={strokeWidth}
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <g id={'guts'}>
                <path
                    d='M11.9998 11.3594V11.1494C11.9998 10.4694 12.4198 10.1094 12.8398 9.8194C13.2498 9.5394 13.6598 9.17941 13.6598
                     8.51941C13.6598 7.59941 12.9198 6.85938 11.9998 6.85938C11.0798 6.85938 10.3398 7.59941 10.3398 8.51941'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M11.9955 13.75H12.0045'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(MessageQuestion, 'message-question');
